/* globals $, kendo, Location */
/*!
    Global.js
    Copyright 2024 Nefab
    Created 2017-06-20 Douglas Nordfeldt
    Updated 2025-04-29 Douglas Nordfeldt
        - From v3.0.0 requires Nef.Base.Mvc.UI v3.0.0
*/
'use strict';

if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function () {
        if (this === '') {
            return this;
        }
        return this.replace(/^\s+|\s+$/g, '');
    };
}
if (typeof String.prototype.truncate !== 'function') {
    String.prototype.truncate = function (length) {
        if (this === '') {
            return this;
        }

        if (this.length <= length) {
            return this;
        }

        var value = this.substring(0, length) + '...';
        return value;
    };
}
if (typeof String.prototype.replaceAll !== 'function') {
    String.prototype.replaceAll = function (pattern, replace) {
        if (this === '') {
            return this;
        }
        var text = this;
        while (text.indexOf(pattern) > -1) {
            text = text.replace(pattern, replace);
        }
        return text;
    };
}
if (typeof String.prototype.capitalizeFirstLetter !== 'function') {
    String.prototype.capitalizeFirstLetter = function () {
        if (this === '') {
            return this;
        }
        return this.charAt(0).toUpperCase() + this.slice(1);
    };
}
if (typeof String.prototype.startsWith !== 'function') {
    String.prototype.startsWith = function (pattern) {
        if (this === '') {
            return false;
        }
        return this.slice(0, pattern.length) === pattern;
    };
}
if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (pattern) {
        if (this === '') {
            return false;
        }
        return this.slice(-pattern.length) === pattern;
    };
}
if (typeof String.prototype.isValidIsoDate !== 'function') {
    String.prototype.isValidIsoDate = function () {
        return nef.validate.isIsoDate(this);
    };
}
if (typeof String.prototype.isValidNorwegianDate !== 'function') {
    String.prototype.isValidNorwegianDate = function () {
        //dd.MM.yyyy
        return /[0-3]{1}[\d]{1}.[0-1]{1}[\d]{1}.[1-2]{1}[\d]{3}/.test(this);
    };
}
if (typeof String.prototype.isValidMacAddress !== 'function') {
    String.prototype.isMacAddress = function () {
        return nef.validate.isMacAddress(this);
    };
}
if (typeof String.prototype.removeHtml !== 'function') {
    String.prototype.removeHtml = function () {
        if (this === '') {
            return this;
        }
        var result = $('<div></div>').html(this).text();
        return result;
    };
}
if (typeof Array.prototype.sortBy !== 'function') {
    Object.defineProperty(Array.prototype, 'sortBy', {
        enumerable: false,
        writable: true,
        value: function () {

            var _dynamicSortMultiple = function () {
                /* save the arguments object as it will be overwritten note that arguments object is an array-like object consisting of the names of the properties to sort by */
                var props = arguments;
                return function (obj1, obj2) {
                    var i = 0, result = 0, numberOfProperties = props.length;
                    /* try getting a different result from 0 (equal) as long as we have extra properties to compare */
                    while (result === 0 && i < numberOfProperties) {
                        result = _dynamicSort(props[i])(obj1, obj2);
                        i++;
                    }
                    return result;
                };
            };
            var _dynamicSort = function (property) {
                var sortOrder = 1;
                if (property[0] === '-') {
                    sortOrder = -1;
                    property = property.substr(1);
                }
                return function (a, b) {
                    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
                    return result * sortOrder;
                };
            };


            return this.sort(_dynamicSortMultiple.apply(null, arguments));
        }
    });
}
if (typeof Array.prototype.distinct !== 'function') {
    Object.defineProperty(Array.prototype, 'distinct', {
        enumerable: false,
        writable: true,
        value: function () {

            var myArray = this, u = {}, a = [];

            for (var i = 0, l = myArray.length; i < l; ++i) {
                if (u.hasOwnProperty(myArray[i])) {
                    continue;
                }
                a.push(myArray[i]);
                u[myArray[i]] = 1;
            }
            return a;
        }
    });
}
if (typeof Array.prototype.shuffle !== 'function') {
    Object.defineProperty(Array.prototype, 'shuffle', {
        enumerable: false,
        writable: true,
        value: function () {

            var arra1 = this;
            var ctr = arra1.length, temp, index;

            // While there are elements in the array
            while (ctr > 0) {
                // Pick a random index
                index = Math.floor(Math.random() * ctr);
                // Decrease ctr by 1
                ctr--;
                // And swap the last element with it
                temp = arra1[ctr];
                arra1[ctr] = arra1[index];
                arra1[index] = temp;
            }
            return arra1;
        }
    });
}

if (typeof Date.prototype.addSeconds !== 'function') {
    Date.prototype.addSeconds = function (seconds) {
        var date = new Date(this.valueOf());
        date.setSeconds(date.getSeconds() + seconds);
        return date;
    };
}
if (typeof Date.prototype.addDays !== 'function') {
    Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    };
}
if (typeof Date.prototype.diff !== 'function') {
    Date.prototype.diff = function (dateToCompare) {
        var ms = (dateToCompare || new Date()) - this;
        var seconds = ms / 1000;
        return Math.floor(seconds);
    };
}
if (typeof Date.prototype.format !== 'function' && typeof kendo !== 'undefined' && kendo.toString) {
    Date.prototype.format = function (format) {
        var result = kendo.toString(this, format);
        return result;
    };
}
if (typeof Date.prototype.toUserLocalDateString !== 'function' && typeof kendo !== 'undefined' && kendo.toString) {
    Date.prototype.toUserLocalDateString = function (format) {
        var result = nef.toUserDateFriendly(this, format);
        return result;
    };
}
if (typeof Date.prototype.toUserLocalTimeString !== 'function' && typeof kendo !== 'undefined' && kendo.toString) {
    Date.prototype.toUserLocalTimeString = function (format) {
        var result = nef.toUserDateTimeFriendly(this, format);
        return result;
    };
}
if (typeof Date.prototype.toUserDateFriendly !== 'function' && typeof kendo !== 'undefined' && kendo.toString) {
    Date.prototype.toUserDateFriendly = function (format) {
        var result = nef.toUserDateFriendly(this, format);
        return result;
    };
}
if (typeof Date.prototype.toUserDateTimeFriendly !== 'function' && typeof kendo !== 'undefined' && kendo.toString) {
    Date.prototype.toUserDateTimeFriendly = function (format) {
        var result = nef.toUserDateTimeFriendly(this, format);
        return result;
    };
}
if (typeof Location.prototype.getQuery !== 'function') {
    Location.prototype.getQuery = function () {
        if (window.location.search === '') {
            return [];
        }
        var data = window.location.search.substring(1).split('&');
        var result = {};
        for (var i = 0; i < data.length; i++) {
            var parts = data[i].split('=');
            var value = decodeURIComponent(parts[1]);

            if (value === '') {
                result[parts[0]] = null;
            }
            else if (!isNaN(value)) {
                result[parts[0]] = value.indexOf('.') > -1 ? parseFloat(value) : parseInt(value);
            }
            else if (Date.parse(value)) {
                result[parts[0]] = new Date(Date.parse(value));
            }
            else if (value.toLowerCase() === 'true') {
                result[parts[0]] = true;
            } else if (value.toLowerCase() === 'false') {
                result[parts[0]] = false;
            } else {
                result[parts[0]] = value;
            }
        }
        return result;
    };
}

var nef = window.nef || {};

if (!nef.ready) {
    nef.ready = (function () {

        var cbs = [];
        //var triggered = false;

        $(kendo).on('nefKendoReady', function () {
            $().ready(function () {
                //triggered = true;
                cbs.forEach(function (cb) {
                    cb();
                });
            });
        });

        return function (cb) {
            cbs.push(cb);
            //if (triggered) {
            //    cb();
            //} else {
            //    cbs.push(cb);
            //}
        };
    })();
}

nef = $.extend(true, {
    version: '3.3.5',
    sitePath: '/',
    lcid: 1033,
    dateFormat: 'yyyy-MM-dd',
    dateTimeFormat: 'yyyy-MM-dd HH:mm',
    timezone: 0,
    log: function () {
        if (window.console && console.log) {
            return Function.prototype.bind.call(console.log, console);
        } else {
            return function () { };
        }
    }(),
    debugger: function (gState, klass) {

        this.debug = {};

        if (window.console && console.log) {
            this.debug.log = console.log.bind(window.console);
        } else {
            this.debug.log = function () { };
        }

        //if (gState && klass.isDebug) {
        //    for (var m in console)
        //        if (typeof console[m] == 'function')
        //            this.debug[m] = console[m].bind(window.console, klass.toString() + ": ")
        //} else {
        //    for (var m in console)
        //        if (typeof console[m] == 'function')
        //            this.debug[m] = function () { }
        //}
        return this.debug;
    },
    deattachEvents: function (domElement, eventName) {

        var events = [];
        var allEvents = $._data(domElement, 'events');
        var currentEvent = allEvents != null ? allEvents[eventName] : null;

        if (currentEvent) {
            for (var i = 0; i < currentEvent.length; i++) {
                events.push(currentEvent[i].handler);
            }
        }

        $(domElement).off(eventName);

        return events;
    },
    reattachEvents: function (domElement, eventName, events) {
        $(domElement).off(eventName);
        if (events) {
            for (var i = 0; i < events.length; i++) {
                $(domElement).on(eventName, events[i]);
            }
        }
    },
    flash: function (options) {

        options = $.extend({
            selector: '#nef_flash_wrapper',
            container: '<div id="SELECTOR"></div>',
            type: 'danger',
            message: '',
            hideAfter: null,
            css: null
        }, options);

        options.container = options.container.replace('SELECTOR', options.selector.replace('#', ''));

        var alertContainer = $(options.selector);
        if (!alertContainer[0]) {
            var target = $('body .breadcrumb');
            if (target[0]) {
                target.after(options.container);
            } else {
                target = $('body .nef-content');
                if (target[0]) {
                    target.prepend(options.container);
                } else {
                    $('body').append(options.container);
                }
            }
            alertContainer = $(options.selector);
        }

        var css = 'alert alert-' + options.type + ' alert-dismissible show fade';

        if (options.css && options.css !== '') {
            css += ' ' + options.css;
        }

        var alertObj = $('<div class="' + css + '" role="alert">' + nef.i18n.translate(options.message) + '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="{t(Common.Close)}"></button></div>');
        alertContainer.append(alertObj);

        if (options.hideAfter && options.hideAfter > 0) {
            window.setTimeout(function () {
                alertObj.find('.btn-close').click();
            }, options.hideAfter);
        }

        return alertObj;
    },
    popupOLD: function (options) {
        var bootstrap_enabled = typeof $().modal === 'function';
        if (bootstrap_enabled) {

            options = $.extend({
                html: '',
                title: '',
                showCloseButton: false,
                modalClass: null,
                bodycss: null,
                modalSize: '',
                backdrop: 'static',
                keyboard: true,
                buttons: [{ text: '{t(Common.Ok)}', isConfirmButton: true }],
                onOpen: null
            }, options);

            var buttonTemplate = '';
            $.each(options.buttons, function (i, elem) {
                var btn = $('<button />').attr('type', 'button').addClass('btn').addClass('btn' + i.toString()).text(elem.text);

                if (elem.class && typeof elem.class === 'string' && elem.class.length > 0) {
                    btn.addClass(elem.class);
                }
                else {
                    btn.addClass((i === options.buttons.length - 1 ? 'btn-primary' : 'btn-secondary'));
                }

                if (elem.isConfirmButton) {
                    btn.addClass('btn-confirm');
                }

                buttonTemplate += btn[0].outerHTML;
            });

            var modalClass = 'nef-popup';
            if (options.modalClass && options.modalClass !== '') {
                modalClass += ' ' + options.modalClass;
            }

            const scope = {
                modalTemplate: '<div class="modal fade ' + modalClass + '" role="dialog">' +
                    '<div class="modal-dialog ' + options.modalSize + '">' +
                    '<div class="modal-content">' +
                    '<div class="modal-body"></div>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                keyupConfirmButton: function (e) {
                    if (e.which === 13) {
                        console.log('keyupConfirmButton', e.which);
                        $modal.find('.modal-footer .btn-confirm').click();
                    }
                }
            };

            //var translated = nef.i18n.translate('<button type="button" class="close">{t(Common.Close)}</button>');

            var $modal = $(scope.modalTemplate);

            if (options.title !== '') {
                var titleHtml = '<div class="modal-header">';
                titleHtml += '<h4 class="modal-title">' + options.title + '</h4>';
                if (options.showCloseButton) {
                    titleHtml += '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="{t(Common.Close)}"></button>';
                }
                titleHtml += '</div>';
                $modal.find('.modal-content').prepend(nef.i18n.translate(titleHtml));
            }

            if (buttonTemplate && buttonTemplate !== '') {
                $modal.find('.modal-content').append('<div class="modal-footer">' + nef.i18n.translate(buttonTemplate) + '</div>');
            }

            var oldKeyUp = nef.deattachEvents(document, 'keyup');

            $.each(options.buttons, function (i, elem) {
                $modal.find('.modal-footer .btn' + i.toString()).click(function (e) {
                    nef.stopEvent(e);

                    if (elem.callback && typeof elem.callback === 'function') {
                        elem.callback($modal);
                    }
                    else {
                        $modal.modal('hide');
                    }
                });
            });

            if (options.bodycss && typeof options.bodycss === 'object') {
                $modal.find('.modal-body').css(options.bodycss);
            }
            else {
                $modal.find('.modal-body').removeAttr('style');
            }

            $(document).on('keyup', scope.keyupConfirmButton);
            //console.log('options', options);
            $modal.modal({
                backdrop: options.backdrop,
                keyboard: options.keyboard
            });

            if (options.onOpen && typeof options.onOpen === 'function') {
                $modal.on('shown.bs.modal', function (e) {
                    options.onOpen($(this));
                    $(this).modal('handleUpdate');
                });
            }

            $modal.on('hidden.bs.modal', function (e) {
                $(this).modal('dispose').remove();
                $(document).off('keyup', scope.keyupConfirmButton);
                nef.reattachEvents(document, 'keyup', oldKeyUp);
            });

            var bodyHtml = typeof options.html === 'string' ? nef.i18n.translate(options.html) : options.html;
            $modal.find('.modal-body').html(bodyHtml);
            $modal.modal('show');
            return $modal;
        }
        else {
            console.error('nef.popup was called but the bootstrap modal component is not loaded');
        }
    },
    popup: function (opt) {

        var bootstrap_enabled = typeof $().modal === 'function';
        if (!bootstrap_enabled) {
            console.error('nef.popup was called but the bootstrap modal component is not loaded');
            return;
        }

        const options = $.extend(false, {}, {
            title: '',
            html: '',
            showCloseButton: false,
            modalClass: '',
            bodycss: '',
            modalSize: '',
            backdrop: 'static',
            keyboard: false,
            focus: true,
            buttons: [{ text: '{t(Common.Ok)}', isConfirmButton: true }],
            onOpening: null,
            onOpen: null,
            target: null,
        }, opt);

        const scope = {
            target: null,
            keyupConfirmButton: function (e) {
                /*console.log('keyupConfirmButton ' + e.which);*/
                if (e.which === 13) {
                    nef.stopEvent(e);
                    $modal.find('.modal-footer .btn-confirm:last').click();
                }
            }
        };

        let hasConfirmButton = false;
        const hasOnOpen = options.onOpen && typeof options.onOpen === 'function';

        let htmlTitle = '';
        if (options.title !== '') {
            htmlTitle += '<div class="modal-header">';
            htmlTitle += '<h4 class="modal-title">' + options.title + '</h4>';
            if (options.showCloseButton) {
                htmlTitle += '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="{t(Common.Close)}"></button>';
            }
            htmlTitle += '</div>';
        }

        const modalClass = options.modalClass && typeof options.modalClass === 'string' ? options.modalClass : '';
        const bodyCss = options.bodycss && typeof options.bodycss === 'string' ? options.bodycss : '';
        const bodyHtml = options.html && typeof options.html === 'string' ? options.html : '';

        let htmlFooter = '';
        if (options.buttons && options.buttons.length > 0) {
            let htmlButtons = '';
            for (let i = 0; i < options.buttons.length; i++) {
                let button = options.buttons[i];

                if (!button.text) {
                    continue;
                }

                let buttonClass = 'btn btn' + i.toString();

                if (button.class && typeof button.class === 'string' && button.class.length > 0) {
                    buttonClass += ' ' + button.class;
                }
                else {
                    buttonClass += i === options.buttons.length - 1 ? ' btn-primary' : ' btn-secondary';
                }

                if (button.isConfirmButton) {
                    hasConfirmButton = true;
                    buttonClass += ' btn-confirm';
                }

                htmlButtons += `<button type="button" class="${buttonClass}">${button.text}</button>`;
            }

            htmlFooter = `<div class="modal-footer">${htmlButtons}</div>`;
        }

        let html = `<div class="modal fade nef-popup ${modalClass}" tabindex="-1">
                    <div class="modal-dialog ${options.modalSize}">
                        <div class="modal-content">
                            ${htmlTitle}
                            <div class="modal-body ${bodyCss}">${bodyHtml}</div>
                            ${htmlFooter}
                        </div>
                    </div>
                </div>`;


        html = nef.i18n.translate(html);
        const $modal = $(html);

        if (options.target) {
            scope.target = $(options.target);
        }

        if (scope.target && scope.target[0]) {
            $modal.appendTo(scope.target);
        }

        if (options.bodycss && typeof options.bodycss === 'object') {
            $modal.find('.modal-body').css(options.bodycss);
        }
        if (options.html && typeof options.html === 'object') {
            $modal.find('.modal-body').html(options.html);
        }

        let oldKeyUp;
        if (hasConfirmButton) {
            oldKeyUp = nef.deattachEvents(document, 'keyup');
            $(document).on('keyup', $modal, scope.keyupConfirmButton);
        }

        $modal.modal({
            backdrop: options.backdrop,
            keyboard: options.keyboard,
            focus: options.focus
        });

        if (options.buttons && options.buttons.length > 0) {
            for (let i = 0; i < options.buttons.length; i++) {
                let button = options.buttons[i];

                $modal.find('.modal-footer .btn' + i.toString()).click(function (e) {
                    nef.stopEvent(e);

                    //console.log('popup click event', button.callback);

                    if (typeof button.callback === 'function') {
                        button.callback($modal);
                    }
                    else {
                        $modal.modal('hide');
                    }
                });
            }
        }

        if (hasOnOpen) {
            $modal.on('shown.bs.modal', function (e) {
                options.onOpen($(this));
                $(this).modal('handleUpdate');
            });
        }

        if (hasConfirmButton) {
            $modal.on('hide.bs.modal', function (e) {
                $(document).off('keyup', $modal, scope.keyupConfirmButton);
                nef.reattachEvents(document, 'keyup', oldKeyUp);
            });
        }

        $modal.on('hidden.bs.modal', function (e) {
            $(this).modal('dispose').remove();
        });

        if (options.onOpening && typeof options.onOpening === 'function') {
            $modal.on('show.bs.modal', function (e) {
                options.onOpening($(this));
            });
        }

        $modal.modal('show');

        return $modal;


    },
    error: function (options, message) {

        let html = '';

        if (typeof options === 'string' && typeof message === 'string') {
            html = `<p class="text-danger">${options}</p><div class="alert alert-light mb-0 overflow-auto" style="max-height:70vh;font-size: .75rem;">${message}</div>`;
        }
        else if (typeof options === 'string') {
            html = `<span class="text-danger">${options}</span>`;
        }
        else if (typeof options.title === 'string' && typeof options.message === 'string') {
            html = `<p class="text-danger">${options.title}</p><div class="alert alert-light mb-0 overflow-auto" style="max-height:70vh;font-size: .75rem;">${options.message}</div>`;
        }
        else if (typeof options.title === 'string') {
            html = `<span class="text-danger">${options.title}</span>`;
        }
        else if (typeof options.message === 'string') {
            html = `<span class="text-danger">${options.message}</span>`;
        }

        return nef.alert(html, options.callback);
    },
    alert: function (message, callback) {

        //if (typeof message === 'string') {
        //    //message = `<p class="text-danger">${genericError}</p><div class="alert alert-light mb-0 overflow-auto" style="max-height:70vh;font-size: .75rem;">${message}</div>`;

        //    message = {
        //        title: '',
        //        message: message
        //    };
        //}

        //if (typeof callback === 'function' && typeof message.callback !== 'function') {
        //    message.callback = callback;
        //}

        //if (typeof message.title === 'undefined') {
        //    message.title = '';
        //}
        //else {
        //    message.title = nef.i18n.translate(message.title);
        //}
        //if (typeof message.message === 'undefined') {
        //    message.message = '';
        //}
        //else {
        //    message.message = nef.i18n.translate(message.message);
        //}

        //let html;

        //if (message.title !== '' && message.message !== '') {
        //    html = `<p class="text-danger">${message.title}</p><div class="alert alert-light mb-0 overflow-auto" style="max-height:70vh;font-size: .75rem;">${message.message}</div>`;
        //}
        //else if (message.title !== '') {
        //    html = message.title;
        //}
        //else{
        //    html = message.message;
        //}

        message = message.replaceAll('\r\n', '<br/>').replaceAll('\n', '<br/>');

        const $modal = this.popup({
            backdrop: 'static',
            keyboard: false,
            focus: true,
            html: message,
            bodycss: { 'text-align': 'center', 'font-size': '20px' },
            buttons: [{
                text: '{t(Common.Ok)}',
                isConfirmButton: true,
                callback: function (modal) {

                    modal.modal('hide');

                    if (typeof callback === 'function') {
                        callback(modal);
                    }
                }
            }],
            //onOpen: function (modal) {
            //    console.log('fiund', $(modal).find('.modal-footer .btn-confirm') )
            //    $(modal).find('.modal-footer .btn-confirm').focus();
            //}
        });

        return $modal;



        //var bootstrap_enabled = typeof $().modal === 'function';
        //if (bootstrap_enabled) {

        //    message = message.replaceAll('\r\n', '<br/>').replaceAll('\n', '<br/>');

        //    var $modal = this.popup({
        //        backdrop: 'static',
        //        keyboard: false,
        //        focus: true,
        //        title: title,
        //        html: message,
        //        bodycss: { 'text-align': 'center', 'font-size': '20px' },
        //        //onOpen: function (modal) {
        //        //    console.log('fiund', $(modal).find('.modal-footer .btn-confirm') )
        //        //    $(modal).find('.modal-footer .btn-confirm').focus();
        //        //}
        //    });

        //    return $modal;

        //} else if (!window.kendo) {
        //    window.alert(nef.i18n.translate(message));
        //    callback && typeof callback === 'function' && callback();
        //}
        //else {
        //    message = message.replaceAll('\r\n', '<br/>').replaceAll('\n', '<br/>');
        //    var html = nef.i18n.translate('<div class="form-horizontal"><div class="form-group"><p class="form-content-static">' + html + '</p></div><div class="form-group"><div class="col-sm-12 text-end"><button type="submit" class="btn btn-primary btnOk">{t(Common.Ok)}</button></div></div></div>');
        //    var confirmElem = $('<div />');
        //    confirmElem.html(html);
        //    confirmElem.kendoWindow({
        //        width: 1000,
        //        visible: false,
        //        actions: ['Close'],
        //        animation: false,
        //        deactivate: function () { this.destroy(); }
        //    });

        //    confirmElem.on('click', 'button', function (e) {
        //        if ($(this).hasClass('btnOk')) {
        //            callback && typeof callback === 'function' && callback();
        //        }

        //        confirmElem.data('kendoWindow').close();
        //        return false;
        //    });

        //    confirmElem.data('kendoWindow').open().center();
        //}
    },
    confirm: function (message, callback, confirmButton, cancelButton) {
        if (typeof message !== 'string') {
            return;
        }
        if (typeof callback !== 'function') {
            return;
        }

        confirmButton = confirmButton || '{t(Common.Confirm)}';
        cancelButton = cancelButton || '{t(Common.Cancel)}';
        message = nef.i18n.translate(message);

        var bootstrap_enabled = typeof $().modal === 'function';
        if (bootstrap_enabled) {

            message = message.replaceAll('\r\n', '<br/>').replaceAll('\n', '<br/>');

            const $modal = this.popup({
                backdrop: 'static',
                keyboard: false,
                focus: true,
                html: message,
                bodycss: { 'text-align': 'center', 'font-size': '20px' },
                buttons: [{
                    text: cancelButton
                },
                {
                    text: confirmButton,
                    isConfirmButton: true,
                    callback: function (modal) {
                        $(modal).modal('hide');
                        callback();
                    },
                }]
            });
            return $modal;

        } else if (!window.kendo) {
            if (window.confirm(message)) {
                callback();
            }
        }
        else {
            const html = nef.i18n.translate('<div class="form-horizontal"><div class="form-group"><p class="form-content-static">' + message + '</p></div><div class="form-group"><div class="col-sm-12 text-end"><button type="button" class="btn btn-default lnkCancel">{t(Common.Cancel)}</button>&nbsp;<button type="submit" class="btn btn-primary lnkSave">{t(Common.Confirm)}</button></div></div></div>');
            const confirmElem = $('<div />');
            confirmElem.html(html);
            confirmElem.kendoWindow({
                width: 1000,
                title: nef.i18n.get('Common.Confirm'),
                visible: false,
                actions: ['Close'],
                animation: false,
                deactivate: function () { this.destroy(); }
            });

            confirmElem.on('click', 'button', function (e) {
                if ($(this).hasClass('lnkSave')) {
                    callback();
                }

                confirmElem.data('kendoWindow').close();
                return false;
            });

            confirmElem.data('kendoWindow').open().center();
        }
    },
    stopEvent: function (e) {
        if (!e) { e = window.event; }

        //e.cancelBubble is supported by IE - this will kill the bubbling process.
        e.cancelBubble = true;
        e.returnValue = false;

        //e.stopPropagation works only in Firefox.
        if (e.stopPropagation) {
            e.stopPropagation();
            e.preventDefault();
        }
        return false;
    },
    chain: function (promises) {
        var def = $.Deferred();
        var total = promises ? promises.length : 0;
        var left = total;

        var next = function (result) {
            if (left <= 0) {
                def.resolve(result);
                return;
            }
            var index = total - left;
            var promise = promises[index];
            if (result) {
                promise.args = promise.args || [];
                promise.args.push(result);
            }
            promise.method.apply(this, promise.args)
                .always(function () {
                    left--;
                }).done(function (result) {
                    next(result);
                }).fail(function (result) {
                    def.reject(result);
                }).progress(function (result) {
                    def.notify(result);
                });
        };
        next(null);
        return def.promise();
    },
    convertUTCDateToLocalDate: function (date) {
        var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();
        newDate.setHours(hours - offset);
        return newDate;
    },
    parseJsonDate: function (dateString) {
        var value = dateString.replace('/Date(', '').replace(')/', '');
        var date = new Date(parseInt(value, 10));
        return date;
    },
    toUserLocalTime: function (date) {
        if (!date) {
            throw new Error('date cannot be NULL!');
        }
        var dateObj = typeof date === 'string' ? new Date(date) : date;

        // First set it back to UTC:
        var offset = dateObj.getTimezoneOffset() * 60;
        var utcDate = dateObj.addSeconds(offset);

        // Second add user timezone:
        var seconds = nef.timezone * 60 * 60;
        utcDate = utcDate.addSeconds(seconds);

        return utcDate;
    },
    toUserDateFriendly: function (date, format) {
        if (!date) {
            return '';
        }

        var dateObj = typeof date === 'string' ? new Date(date) : date;
        var userDate = nef.toUserLocalTime(dateObj);

        format = format || nef.dateFormat;

        var result = userDate.format(format);
        return result;
    },
    toUserDateTimeFriendly: function (date, format) {
        return nef.toUserDateFriendly(date, format || nef.dateTimeFormat);
    },
    toUserLocalTimeString: function (date, format) {
        if (!date) {
            return '';
        }
        var dateObj = typeof date === 'string' ? new Date(date) : date;

        var userDate = nef.toUserLocalTime(dateObj);
        var offset = userDate.getTimezoneOffset() * 60;
        var utcDate = dateObj.addSeconds(offset);

        format = format || nef.dateTimeFormat;
        var result = '<span title="UTC: ' + utcDate.format(format) + '">' + userDate.format(format) + '</span>';
        return result;
    },
    toUserLocalDateString: function (date, format) {
        if (!date) {
            return '';
        }
        var dateObj = typeof date === 'string' ? new Date(date) : date;

        var userDate = nef.toUserLocalTime(dateObj);
        var offset = userDate.getTimezoneOffset() * 60;
        var utcDate = dateObj.addSeconds(offset);

        format = format || nef.dateFormat;
        var result = '<span title="UTC: ' + utcDate.format(format) + '">' + userDate.format(format) + '</span>';

        return result;
    },
    toUserNumberFriendly: function (number, format) {

        if (number === null) {
            return '';
        }

        var isDecimalNumber = number % 1 != 0;
        format = format || (isDecimalNumber ? 'n' : 'n0');

        var result = kendo.toString(number, format);
        if (result && result !== '' && result.indexOf(' ') > -1) {
            return '<span class="text-nowrap">' + result + '</span>';
        }

        return result;
    },
    getEnumFlags: function (enu, value) {
        var values = [];
        for (var i in enu) {
            if (enu[i] > 0 && (value & enu[i]) === enu[i]) {
                values.push(i);
            }
        }
        if (values.length === 0) {
            values.push('None');
        }
        return values;
    },
    getEnumName: function (enu, value) {
        for (var i in enu) {
            if (enu[i] === value) {
                return i;
            }
        }
        return 'None';
    },
    formAjaxSubmit: function (options) {

        options = $.extend({
            debug: false,
            formSelector: '.nef-content form',
            form: null,
            modal: null,
            beforeSubmit: null,
            success: null,
            error: null
        }, options);

        var log = function () {
            if (options.debug) {
                return Function.prototype.bind.call(console.log, nef, 'nef.formAjaxSubmit:');
            } else {
                return function () { };
            }
        }();

        var deferred = $.Deferred();

        var $forms = options.form ? $(options.form) : $(options.formSelector);
        if (!$forms[0]) {
            nef.log('nef.formAjaxSubmit:', 'Cannot find the form "' + options.formSelector + '"!');
            return false;
        }

        nef.Bootstrap.prepeareFormMVC({
            formSelector: $forms
        });

        $forms.each(function () {

            var $form1 = $(this);

            //Very important that this run before .validate()!!
            $.validator.unobtrusive.parse($form1);
            var validator = $form1.validate();

            validator.settings.submitHandler = function (form) {
                log('form submitHandler');

                var $form = $(form);
                var $fieldset = $form.find('fieldset').first();
                var data = new FormData(form);

                $fieldset.prop('disabled', true);
                kendo.ui.progress($form, true);

                if (typeof options.beforeSubmit === 'function') {
                    options.beforeSubmit(data, form);
                }

                $.ajax({
                    url: $form.attr('action'),
                    type: $form.attr('method'),
                    data: data,
                    contentType: false,
                    processData: false,
                    success: function (result) {
                        log('success!', result);
                        $fieldset.prop('disabled', false);
                        kendo.ui.progress($form, false);

                        if (options.modal) {
                            if (result.success) {
                                options.modal.modal('hide');
                                nef.flash({
                                    message: result.message,
                                    type: 'success'
                                });
                            } else {
                                $form.find('.alert').html(result.message).removeClass('validation-summary-valid').addClass('validation-summary-errors');
                            }
                        }

                        if (typeof options.success === 'function') {
                            options.success(result, form);
                        }

                        deferred.resolve(result, form);
                    },
                    error: function (result) {
                        console.log('nef.formAjaxSubmit:', 'Error submitting the form!!!', result);
                        $fieldset.prop('disabled', false);
                        kendo.ui.progress($form, false);

                        if (options.modal) {
                            var error = result.message || result;
                            var $alert = $form.find('.alert');
                            if ($alert[0]) {
                                $alert.html(error).removeClass('validation-summary-valid').addClass('validation-summary-errors');
                            }
                            else {
                                nef.alert(error);
                            }
                        }

                        if (typeof options.error === 'function') {
                            options.error(result, form);
                        }

                        deferred.reject(result, form);
                    }
                });

                return false;
            };

        });

        return deferred.promise();
    },
    ajaxFailed: function (xhr) {
        console.log('AJAX ERROR!', xhr, this);
        var message = xhr.responseText && xhr.responseText !== '' ? xhr.responseText : xhr.statusText;
        nef.alert(nef.i18n.get('Common.GenericError') + '<br/><br/>' + xhr.status + ' ' + message);
    },
    keepAlive: function (options) {

        options = $.extend({
            id: '',
            url: '',
            keepAlive: false,
            interval: 1000 * 60 * 10
        }, options);

        var iframe = $('<iframe id="' + options.id + '" class="nef-keepAlive" hidden></iframe>');

        $('body').append(iframe);
        iframe.attr('src', options.url);

        if (options.keepAlive) {
            window.setInterval(function () {
                //console.log('nef.keepAlive: Pinging "' + options.id + '" at "' + options.url + '"...');
                iframe.attr('src', options.url);
            }, options.interval);
        }
    },
    renewSts: function (keepAlive) {
        var options = {
            id: 'nef-sts-renewStsSession',
            url: '/login/alive',
            keepAlive: keepAlive,
        };
        nef.keepAlive(options);
    },
    forceLogin: function (keepAlive) {

        //http://www.cloudidentity.com/blog/2016/07/25/controlling-a-web-apps-session-duration-2/
        var options = {
            id: 'nef-sts-forceLogin',
            url: nef.sitePath + 'Base/Account/ForcedSignIn',
            keepAlive: keepAlive,
        };
        nef.keepAlive(options);
    },
    addSpacesToSentence: function (text, preserveAcronyms) {
        if (!text || text === '')
            return text;

        var isUpper = function (character) {
            if (!isNaN(character))
                return true;

            return character == character.toUpperCase();
        };

        var newText = text[0];

        for (var i = 1; i < text.length; i++) {
            if (isUpper(text[i])) {

                if (
                    (text[i - 1] != ' ' && !isUpper(text[i - 1]))
                    ||
                    (preserveAcronyms && isUpper(text[i - 1]) && i < text.length - 1 && !isUpper(text[i + 1]))
                ) {
                    newText += ' ';
                }

            }
            newText += text[i];

        }
        return newText;
    },
    round: function (value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    },
    validate: {
        _regExMac: /^[0-9a-f]{1,2}([\.:-])(?:[0-9a-f]{1,2}\1){4}[0-9a-f]{1,2}$/i,
        isMacAddress: function (value) {
            if (!value || value === '') {
                return false;
            }
            var result = this._regExMac.test(value);
            return result;
        },
        _regExIsoDate: /^[1-2]{1}[\d]{3}-[0-1]{1}[\d]{1}-[0-3]{1}[\d]{1}$/,
        isIsoDate: function (value) {
            if (!value || value === '') {
                return false;
            }
            var result = this._regExIsoDate.test(value);
            return result;
        }
    },
    convert: {
        millimetersToInchs: function (millimeters) {
            return millimeters / 25.4;
        },
        inchsToMillimeters: function (feet) {
            return feet * 25.4;
        },
        metersToFeet: function (meters) {
            return meters / 0.3048;
        },
        feetToMeters: function (feet) {
            return feet * 0.3048;
        },
        kilometersToMiles: function (kilometers) {
            return kilometers / 1.609344;
        },
        milesToKilometers: function (miles) {
            return miles * 1.609344;
        },
        kilogramsToPounds: function (kilograms) {
            return kilograms / 0.45359237;
        },
        poundsToKilograms: function (pounds) {
            return pounds * 0.45359237;
        },
        kmhToKnots: function (kilometersPerHour) {
            return kilometersPerHour / 1.852;
        },
        knotsToKmh: function (knots) {
            return knots * 1.852;
        },
        mpsToKnots: function (milesPerHour) {
            return milesPerHour / 1.150779448;
        },
        knotsToMps: function (knots) {
            return knots * 1.150779448;
        },
        celsiusToFahrenheit: function (celsius) {
            var fahrenheit = (celsius * 9) / 5 + 32;
            return fahrenheit;
        },
        fahrenheitToCelsius: function (fahrenheit) {
            var celsius = (fahrenheit - 32) * 5 / 9;
            return celsius;
        },
        HexToRGB: function (hex, alpha) {
            hex = hex.replace('#', '');
            var r = parseInt(hex.substring(0, 2), 16);
            var g = parseInt(hex.substring(2, 4), 16);
            var b = parseInt(hex.substring(4, 6), 16);

            var result = '';
            if (alpha) {
                result = 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
            } else {
                result = 'rgb(' + r + ',' + g + ',' + b + ')';
            }
            return result;
        },
        b64toBlob: function (b64Data, contentType = '', sliceSize = 512) {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },
    },
    getAntiForgeryToken: function () {
        var hidden = $('#nef-AntiForgeryToken input:hidden');
        if (hidden) {
            return {
                value: hidden.val(),
                name: hidden.attr('name')
            };
        }
        return null;
    },
    keepBrowserActive: function (options) {

        options = $.extend({
            name: 'nef.keepBrowserActiveLock',
            mode: 'shared',
        }, options);

        var lockResolver;
        if (navigator && navigator.locks && navigator.locks.request) {

            const promise = new Promise((res) => {
                lockResolver = res;
            });

            navigator.locks.request(options.name, { mode: options.mode }, () => {
                return promise;
            });
        }
        return lockResolver;
    },
    isMobileDevice: function () {
        var userAgent = navigator.userAgent || window.opera;
        var isMobile = !userAgent || userAgent.indexOf('Mobi') > -1;
        return isMobile;
    },
    logging: {
        save: function (event) {

            nef.logging.lastErrorEvent = event;

            const data = {
                url: location.toString(),
                filename: event.filename && event.filename !== '' ? event.filename : 'inline',
                lineno: event.lineno,
                colno: event.colno,
                type: event.type,
                timeStamp: event.timeStamp ? nef.round(event.timeStamp) : -1,
                name: event.name,
                //triggeredBy: event.isTrusted ? 'browser' : 'script',
                //message: event.message,
                //stack: event.stack,
            };

            const lastXhr = nef.logging.lastXhr;
            if (lastXhr) {
                const params = lastXhr.data && lastXhr.data !== '' ? lastXhr.data.truncate(200) : '';
                const timeStamp = lastXhr.timeStamp ? `${nef.round(new Date().getTime() - lastXhr.timeStamp)}ms ago to` : 'to';
                data.lastXhr = `${lastXhr.type} ${timeStamp} '${lastXhr.url}' data=${params}`;
            }

            data.message = event.message;
            data.stack = event.stack;

            const error = event.error;
            if (error) {
                data.name = error.name;
                data.message = error.message;
                data.stack = error.stack;
            }

            const reason = event.reason;
            if (reason) {
                data.name = reason.name;
                data.message = reason.message;
                data.stack = reason.stack;
            }

            /*
                Getting a lot of errors like this that we cannot do anything about:
                stack: TypeError: Cannot read properties of null (reading 'type')
                    at Ln.<anonymous> (chrome-extension://egjidjbpglichdcondbcbdnbeeppgdph/inpage.js:247:166515)
                    at Generator.next (<anonymous>)
                    at ae (chrome-extension://egjidjbpglichdcondbcbdnbeeppgdph/inpage.js:247:165403)

            */
            if (data.stack && data.stack !== '' && data.stack.indexOf('chrome-extension://') > -1) {
                return;
            }

            const path = data.url.replace(location.origin, '').replace(nef.sitePath, '');
            const message = path + ': ' + data.message;

            let fullmessage = '';
            for (let key in data) {
                fullmessage += `${key}: ${data[key]}\r\n`;
            }

            //console.warn('nef[' + data.type + ']: ' + data.message, event, fullmessage);

            $(document).ready(function () {
                $.ajax({
                    url: nef.sitePath + 'Base/Errors/JsError',
                    method: 'POST',
                    data: {
                        message: message,
                        data: fullmessage
                    },
                    global: false,
                    beforeSend: function (xmlHttpRequest) {
                        const token = nef.getAntiForgeryToken();
                        if (token) {
                            xmlHttpRequest.setRequestHeader(token.name.replace('__', ''), token.value);
                        }
                    },
                    complete: function () { }
                });
            });
        },
        logLastXhr: function (event, jqXHR, settings) {
            nef.logging.lastXhr = {
                url: settings.url,
                type: settings.type,
                data: settings.data,
                timeStamp: event.timeStamp
            };
        },
        logJavascriptErrors: function () {

            $(document)
                .off('ajaxSend', nef.logging.logLastXhr)
                .on('ajaxSend', nef.logging.logLastXhr)
                ;

            window.removeEventListener('error', nef.logging.save);
            window.removeEventListener('unhandledrejection', nef.logging.save);

            window.addEventListener('error', nef.logging.save);
            window.addEventListener('unhandledrejection', nef.logging.save);
        }
    }
}, nef);

nef.logging.logJavascriptErrors();



nef.i18n = $.extend(true, {
    debug: false,
    lcid_default: 1033,
    init: function (lcid) {

        var log = function () {
            if (nef.i18n.debug) {
                return Function.prototype.bind.call(nef.log, nef, 'nef.i18n.init:');
            } else {
                return function () { };
            }
        }();

        log('setting language to "' + lcid + '"...');

        if (!lcid) {
            if (window.SP && window.SP.Res && window.SP.Res.lcid) {
                lcid = parseInt(window.SP.Res.lcid, 10);
            } else {
                lcid = nef.lcid || this.lcid_default;
            }
        }
        else if (typeof lcid === 'string') {
            switch (lcid) {
                case 'sv-SE':
                    lcid = 1053;
                    break;
                //case 'en-US':
                default:
                    lcid = 1033;
                    break;
            }

            log('correct LCID value is ' + lcid);
        }

        if (this.translations[lcid]) {
            //var translation = this.lcid_default !== lcid ? nef.copyMerge(this.translations[this.lcid_default], this.translations[lcid], true) : this.translations[lcid];
            var translation = this.translations[lcid];
            //Douglas [2019-03-12]: I this really needed?
            //if (this.lcid_default !== lcid) {
            //    $.extend(true, translation, this.translations[this.lcid_default], this.translations[lcid]);
            //}
            log('changed language to ' + lcid + '!');
            nef.lcid = lcid;
            nef.t = translation;
        }
    },
    _translateRegex: RegExp(/\{t\(([\w\.]+)\)([a-z]{0,1})\}/),
    _getByString: function (o, s) {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    },
    get: function (key, params) {
        return this.getByLCID(nef.lcid, key, params);
    },
    getByLCID: function (lcid, key, params) {
        /*
        console.log('Test1: ' + nef.translate('common.save'));
        // Test1: Spara
        console.log('Test2: ' + nef.translate('common.complex', ['Douglas', 'winner']));
        // Test2: Douglas är en winner!
        console.log('Test3: ' + nef.translate('common.complex', ['Douglas', '||common.winner']));
        // Test3: Douglas är en Vinnare!
        */
        var log = function () {
            if (nef.i18n.debug) {
                return Function.prototype.bind.call(nef.log, nef, 'nef.i18n.getByLCID [' + lcid + ']:');
            } else {
                return function () { };
            }
        }();

        if (!this.translations[lcid]) {
            log('LCID "' + lcid + '" is not translated! Using "' + this.lcid_default + '" instead.');
            lcid = this.lcid_default;
        }

        var _key = lcid + '.' + key;

        var value = this.translations[lcid][key];
        if (!value && lcid !== this.lcid_default) {
            log('Not found "' + _key + '", trying with default LCID "' + this.lcid_default + '" instead.');
            value = this._getByString(this.translations, this.lcid_default + '.' + key);
        }

        if (!value) {
            log('Not found "' + _key + '"!');
            value = _key;
        } else {
            if (params && params.length > 0) {
                var i = 0, arg;
                for (i = 0; i < params.length; i++) {
                    arg = params[i];
                    if (typeof arg === 'string' && arg.startsWith('||')) {
                        arg = this.getByLCID(lcid, arg.replace('||', ''));
                    }
                    value = value.replaceAll('{' + i + '}', arg);
                }
            }
        }

        return value;
    },
    translate: function (text) {
        /* 
            var text = 'detta är min text {t(common.save)} som ska {t(common.ok)} översättas';
        */

        if (!text || text === '')
            return '';

        var log = function () {
            if (nef.i18n.debug) {
                return Function.prototype.bind.call(nef.log, nef, 'nef.translate:');
            } else {
                return function () { };
            }
        }();

        log('Translating: ' + text);
        var regex = this._translateRegex;
        var match, translated = '', index = 0;
        while (index < 9999 && (match = regex.exec(text))) {
            log('Found ' + match[0], match);
            translated = this.get(match[1]);
            if (match[2]) {
                if (match[2] === 'l') {
                    translated = translated.toLowerCase();
                } else if (match[2] === 'u') {
                    translated = translated.toUpperCase();
                }
            }
            text = text.replaceAll(match[0], translated);
            index++;
        }
        log(index, text);
        return text;
    },
    translations: null
}, nef.i18n);

nef.i18n.init();



nef.validator = $.extend(true, {
    init: function (options) {

        options = $.extend({
            numDecSep: null,
            calendar: {
                d: null,
            }
        }, options);

        // Override the default ignore setting after including jquery.validate.unobtrusive.min.js to enable validation of hidden elements.For instance, widgets like the Kendo UI DropDownList and NumericTextBox have a hidden input to keep the value.
        /*$.validator.setDefaults({ ignore: '' });*/

        $.validator.setDefaults({
            // Override the default ignore setting after including jquery.validate.unobtrusive.min.js to enable validation of hidden elements.For instance, widgets like the Kendo UI DropDownList and NumericTextBox have a hidden input to keep the value.
            ignore: '',
            //errorContainer: '.validation-summary-valid',
            //errorContainer: '',
            highlight: function (el, errorClass, validClass) {
                //console.log(el.id, errorClass, validClass, el);
                var $el = $(el);
                $el.addClass('border-danger').removeClass('border-success');
                $el.closest('.form-group').addClass('has-error');

                if ($el.hasClass('k-input-inner')) {
                    $el.parent().addClass('border-danger').removeClass('border-success');
                } else {
                    var parent = $el.parent();
                    if (parent.hasClass('k-widget')) {
                        parent.children(':first').addClass('border-danger').removeClass('border-success');
                    }
                    else if (parent.hasClass('k-picker')) {
                        parent.addClass('border-danger').removeClass('border-success');
                    }
                }
            },
            unhighlight: function (el, errorClass, validClass) {
                var $el = $(el);
                $el.removeClass('border-danger').addClass('border-success');
                $el.closest('.form-group').removeClass('has-error');

                if ($el.hasClass('k-input-inner')) {
                    $el.parent().removeClass('border-danger').addClass('border-success');
                } else {
                    var parent = $el.parent();
                    if (parent.hasClass('k-widget')) {
                        parent.children(':first').removeClass('border-danger').addClass('border-success');
                    } else if (parent.hasClass('k-picker')) {
                        parent.removeClass('border-danger').addClass('border-success');
                    }
                }
            },
            submitHandler: function (form) {
                var $form = $(form);
                $form.find('input[type="submit"], button[type="submit"]').prop('disabled', true);
                kendo.ui.progress($form, true);

                // Prevent double submission
                if (!this.beenSubmitted) {
                    this.beenSubmitted = true;
                    form.submit();
                }
            }
            //invalidHandler: function (event, validator) {
            //    // Code to run when form is invalid
            //    // You can display a custom message or take other actions
            //    console.log('invalidHandler', event, validator);
            //}
        });

        if (options.calendar && options.calendar.d && options.calendar.d !== '') {

            var dateFormat = options.calendar.d;

            if (dateFormat === 'yyyy-MM-dd') {
                $.validator.addMethod('date', function (value, element, params) {
                    if (this.optional(element)) {
                        return true;
                    }
                    return value.isValidIsoDate();
                }, '');
            }
            else if (dateFormat === 'dd.MM.yyyy') {
                $.validator.addMethod('date', function (value, element, params) {
                    if (this.optional(element)) {
                        return true;
                    }
                    return value.isValidNorwegianDate();
                }, '');
            }
        }

        if (options.numDecSep && options.numDecSep !== '') {

            var isCommaDecSep = options.numDecSep === ',';

            if (isCommaDecSep) {
                //http://blog.rebuildall.net/2011/03/02/jQuery_validate_and_the_comma_decimal_separator
                $.validator.methods.range = function (value, element, param) {
                    var globalizedValue = value.replace(',', '.');
                    return this.optional(element) || (globalizedValue >= param[0] && globalizedValue <= param[1]);
                };
                $.validator.methods.min = function (value, element, param) {
                    var globalizedValue = value.replace(',', '.');
                    return this.optional(element) || globalizedValue >= param;
                };
                $.validator.methods.max = function (value, element, param) {
                    var globalizedValue = value.replace(',', '.');
                    return this.optional(element) || globalizedValue <= param;
                };
                $.validator.methods.number = function (value, element) {
                    return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:[\s\.,]\d{3})+)(?:[\.,]\d+)?$/.test(value);
                };
            }
        }
    },
}, nef.validator);

nef.validator.init(nef.culture);



nef.Kendo = $.extend(true, {
    Grid: {
        getErrorMessage: function (grid, e) {
            console.error('nef.Kendo.Grid: dataSource.Error', e.status, e.statusText, e);

            //let grid = e.sender;
            if (grid && grid.nef && grid.nef.lastRequestType && grid.nef.lastRequestType === 'destroy') {
                grid.cancelChanges();
            }

            const genericError = nef.i18n.get('Common.GenericError');
            let message = '';

            if (e.errors) {

                const errors = [];

                $.each(e.errors, function (key, value) {
                    if (value.errors) {
                        if (typeof value.errors === 'string') {
                            //message += kendo.htmlEncode(value.errors) + '<br/><br/>';
                            errors.push(kendo.htmlEncode(value.errors));
                        }
                        else {
                            $.each(value.errors, function () {
                                //message += kendo.htmlEncode(this) + '<br/><br/>';
                                errors.push(kendo.htmlEncode(this));
                            });
                        }
                    }

                    //if ('errors' in value) {
                    //    $.each(value.errors, function () {
                    //        message += this + '<br/><br/>';
                    //    });
                    //}
                });

                if (errors.length > 0) {
                    message += errors.join('<br/><br/>');
                }
            }
            else if (e.xhr && e.xhr.responseText && e.xhr.responseText !== '') {

                if (e.xhr.responseText.startsWith('<!DOCTYPE') || e.xhr.responseText.startsWith('<html')) {

                }
                else {
                    message += kendo.htmlEncode(e.xhr.responseText.truncate(200));
                }
            }
            else if (e.xhr && e.xhr.status !== 500 && e.xhr.statusText && e.xhr.statusText !== '') {
                message += '<b>' + kendo.htmlEncode(e.xhr.status) + '</b> ' + kendo.htmlEncode(e.xhr.statusText.truncate(200));
            }

            const result = {
                message: message
            }

            if (message !== genericError) {
                result.title = genericError;
            }

            return result;
        },
        prepare: function (opt) {


            if (opt && typeof opt.persistState === 'boolean') {
                opt.persistState = {
                    enabled: opt.persistState,
                };
            }
            if (opt && typeof opt.persistStateCacheKey === 'string') {
                opt.persistState = opt.persistState || {};
                opt.persistState.key = opt.persistStateCacheKey;
                delete opt.persistStateCacheKey;
            }

            const options = $.extend(true, {
                gridSelector: '.k-grid',
                hidePagingWhenOnlyHaveOnePage: false,
                persistState: {
                    enabled: true,
                    key: 'nef.grid-' + nef.pageName,
                    timeout: 1200,
                    overrideColumns: null,
                    defaultFilter: null,
                }
            }, opt);

            if (!options.persistState) {
                options.persistState = {
                    enabled: false
                };
            }

            //console.log('prepareGrid', options);

            const scope = {
                setPeristState: function (grid) {

                    if (options.persistState.enabled && grid.nef && grid.nef.setState) {

                        grid.nef.setState = false;

                        var dataSource = grid.dataSource;
                        var state = {
                            time: new Date(),
                            page: dataSource.page(),
                            pageSize: dataSource.pageSize(),
                            sort: dataSource.sort(),
                            filter: dataSource.filter(),
                            group: dataSource.group()
                        };

                        sessionStorage.setItem(grid.nef.persistStateKey, JSON.stringify(state));
                    }
                },
                _onDataSourceReady: {
                    callbacks: [],
                    loaded: false,
                    handler: function (e) {
                        //console.log('onDataSourceReady.dataBinding ' + scope._onDataSourceReady.callbacks.length, e);

                        let grid = e.sender;
                        //grid.nef.isBounded = true;
                        grid.nef.lastRequestType = e.action;

                        grid.unbind('dataBinding', scope._onDataSourceReady.handler);

                        var callbacks = scope._onDataSourceReady.callbacks;
                        for (var i = 0; i < callbacks.length; i++) {
                            callbacks[i](grid.dataSource);
                        }
                    },
                },
                onDataSourceReady: function (grid, disableAutoBind, callback) {

                    if (grid.dataSource) {

                        if (disableAutoBind) {
                            grid.options.autoBind = false;
                        }

                        callback(grid.dataSource);
                    }
                    else {

                        scope._onDataSourceReady.callbacks.push(callback);

                        if (!scope._onDataSourceReady.loaded) {

                            scope._onDataSourceReady.loaded = true;


                            var colDataSources = [];

                            for (let i = 0; i < grid.columns.length; i++) {
                                const col = grid.columns[i];
                                if (col.dataSource) {
                                    colDataSources.push(col.dataSource);
                                }
                            }

                            if (disableAutoBind && colDataSources.length === 0) {
                                // Set to false to prevent uneeded load in case we should load the state...
                                // If Grid has ForeignKey columns that will fetch data, then this will break this code and Grid will not load...
                                grid.options.autoBind = false;
                            }

                            grid.bind('dataBinding', scope._onDataSourceReady.handler);
                        }
                    }
                },
                overrideColumnValues: function (overrideCols, state) {

                    const updateCols = function (col, filters) {

                        if (!filters || filters.length === 0) {
                            return;
                        }

                        for (let i = 0; i < filters.length; i++) {
                            const filter = filters[i];
                            if (filter.field) {

                                if (filter.field === col.field) {
                                    //console.log('overrideColumnValues ' + col.field, col, state)
                                    filter.value = col.value;
                                }
                            }
                            else {
                                updateCols(col, filter.filters);
                            }
                        }

                    };

                    if (overrideCols && overrideCols.length > 0 && state.filter && state.filter.filters) {
                        for (let i = 0; i < overrideCols.length; i++) {
                            updateCols(overrideCols[i], state.filter.filters);
                        }
                    }
                },
                addDefaultFilter: function (overrideCols, state) {
                    const updateCols = function (col, filters) {

                        if (!filters || filters.length === 0) {
                            return false;
                        }

                        for (let i = 0; i < filters.length; i++) {
                            const filter = filters[i];
                            if (filter.field) {
                                if (filter.field === col.field) {
                                    return true;
                                }

                            }
                            else {
                                var found = updateCols(col, filter.filters);
                                if (found) {
                                    return true;
                                }
                            }
                        }

                        return false;
                    };

                    if (overrideCols && overrideCols.length > 0) {

                        if (!state.filter) {
                            state.filter = { logic: 'and', filters: [] };
                        }
                        if (!state.filter.filters) {
                            state.filter.filters = [];
                        }

                        for (let i = 0; i < overrideCols.length; i++) {
                            var col = overrideCols[i];

                            var found = updateCols(col, state.filter.filters);
                            if (!found) {

                                //console.log('addDefaultFilter ' + col.field, col, state)

                                state.filter.filters.push({
                                    field: col.field,
                                    value: col.value,
                                    operator: col.operator || 'eq'
                                });
                            }
                        }
                    }


                },
                configure: function (grid) {

                    grid.nef = {
                        lastRequestType: null,
                        isBounded: false
                    };

                    //console.log('prepare grid!', typeof grid.dataSource, grid.options.autoBind);

                    //scope.onDataSourceReady(grid, false, function (dataSource) {
                    //    console.log('onDataSourceReady test1');
                    //});
                    //scope.onDataSourceReady(grid, false, function (dataSource) {
                    //    console.log('onDataSourceReady test2');
                    //});

                    // If autobind = false then dataSource is null and this is the firts time we can bind to it!
                    scope.onDataSourceReady(grid, false, function (dataSource) {

                        dataSource.bind('requestStart', function (e) {
                            //console.log('requestStart', e);
                            grid.nef.lastRequestType = e.type;
                        });
                        dataSource.bind('error', function (e) {

                            const message = nef.Kendo.Grid.getErrorMessage(grid, e);

                            //console.error('Kendo.UI.Grid: dataSource.Error: ', e.status, e.statusText, e);
                            ////let grid = e.sender;

                            //if (grid.nef.lastRequestType && grid.nef.lastRequestType === 'destroy') {
                            //    grid.cancelChanges();
                            //}

                            //let message = nef.i18n.get('Common.GenericError') + '<br/><br/>';

                            //if (e.errors) {
                            //    $.each(e.errors, function (key, value) {
                            //        if (value.errors) {
                            //            if (typeof value.errors === 'string') {
                            //                message += kendo.htmlEncode(value.errors) + '<br/><br/>';
                            //            }
                            //            else {
                            //                $.each(value.errors, function () {
                            //                    message += kendo.htmlEncode(this) + '<br/><br/>';
                            //                });
                            //            }
                            //        }

                            //        //if ('errors' in value) {
                            //        //    $.each(value.errors, function () {
                            //        //        message += this + '<br/><br/>';
                            //        //    });
                            //        //}
                            //    });
                            //}
                            //else if (e.xhr.responseText && e.xhr.responseText !== '') {
                            //    message += kendo.htmlEncode(e.xhr.responseText.truncate(200));
                            //}
                            //else if (e.xhr.status !== 500 && e.xhr.statusText && e.xhr.statusText !== '') {
                            //    message += '<b>' + kendo.htmlEncode(e.xhr.status) + '</b> ' + kendo.htmlEncode(e.xhr.statusText.truncate(200));
                            //}
                            console.log('grid felet', message)
                            nef.error(message);
                        });
                    });

                    if (options.hidePagingWhenOnlyHaveOnePage || options.persistState.enabled) {

                        grid.bind('dataBound', function (e) {

                            let grid = e.sender;

                            if (options.hidePagingWhenOnlyHaveOnePage) {
                                if (grid.dataSource.totalPages() === 1) {
                                    grid.pager.element.hide();
                                } else {
                                    grid.pager.element.show();
                                }
                            }

                            if (options.persistState.enabled) {
                                scope.setPeristState(grid);
                            }
                        });
                    }


                    // If autobind = false then dataSource is null!
                    //if (options.persistState && grid.dataSource) {
                    if (options.persistState.enabled) {

                        const gridName = grid.element.attr('id');
                        const query = window.location.getQuery();
                        const hasQuery = window.location.search.indexOf('?' + gridName + '-') > -1 || window.location.search.indexOf('&' + gridName + '-') > -1;

                        let dataLoaded = grid.options.autoBind;

                        //grid.nef.persistStateKey = options.persistState.key && options.persistState.key !== '' ? options.persistState.key : 'nef.grid-' + nef.pageName;
                        grid.nef.persistStateKey = options.persistState.key + '-' + gridName;
                        //grid.nef.persistStateKey += '-' + gridName;
                        grid.nef.setState = false;

                        const eventsToBind = ['page', 'sort', 'filter', 'group', 'groupExpand', 'groupCollapse'];
                        for (let i = 0; i < eventsToBind.length; i++) {
                            grid.bind(eventsToBind[i], function (e) {
                                e.sender.nef.setState = true;
                            });
                        }

                        if (query.gridPersistState === 'clear' || hasQuery) {
                            sessionStorage.removeItem(grid.nef.persistStateKey);
                        }
                        else {

                            const savedState = sessionStorage.getItem(grid.nef.persistStateKey);

                            if (savedState) {

                                const state = JSON.parse(savedState);
                                const stateDate = new Date(state.time);

                                if (stateDate.diff() < options.persistState.timeout) {

                                    scope.overrideColumnValues(options.persistState.overrideColumns, state);
                                    scope.addDefaultFilter(options.persistState.defaultFilter, state);
                                    state.time = new Date();
                                    sessionStorage.setItem(grid.nef.persistStateKey, JSON.stringify(state));

                                    scope.onDataSourceReady(grid, true, function (dataSource) {

                                        dataSource.query({
                                            page: state.page,
                                            pageSize: state.pageSize,
                                            sort: state.sort,
                                            filter: state.filter,
                                            group: state.group
                                        });
                                    });

                                    dataLoaded = true;
                                }
                            }
                        }

                        if (!dataLoaded) {
                            scope.onDataSourceReady(grid, false, function (dataSource) {
                                dataSource.read();
                            });
                        }
                    }
                }
            };

            $(document).ready(function () {
                $(options.gridSelector).each(function () {
                    let grid = $(this).data('kendoGrid');
                    if (grid) {
                        scope.configure(grid);
                    }
                });
            });

        },
        hidePagingWhenOnlyHaveOnePage: function () {
            if (this.dataSource.totalPages() === 1) {
                this.pager.element.hide();
            } else {
                this.pager.element.show();
            }
        },
        ColumnTemplates: {
            userRoles: function (role) {
                var flags = nef.getEnumFlags(nef.userRoles, role);
                return flags.join(', ');
            },
            boolean: function (value) {
                if (value) {
                    return '<div class="text-success">' + nef.i18n.get('Common.Yes') + '</div>';
                }
                return '<div class="text-danger"><b>' + nef.i18n.get('Common.No') + '<b></div>';
            },
            languages: function (lcids) {
                if (!lcids) {
                    return '';
                }
                var html = '', lang = '';
                for (var i = 0; i < lcids.length; i++) {
                    lang = nef.Kendo.Grid.ColumnTemplates.language(lcids[i]);
                    if (lang !== '') {
                        if (html !== '') {
                            html += ', ';
                        }
                        html += lang;
                    }
                }

                return html;
            },
            language: function (lcid) {
                if (!lcid) {
                    return '';
                }
                var language = nef.languages[lcid];
                if (language) {
                    return '<span class="fi fi-' + language.FlagName + '" title="' + language.Name + '"></span> ' + language.DisplayName;
                }
                return '';
            }
        },
        redirectToDetails: function (self, e, url) {
            nef.stopEvent(e);
            var dataItem = self.dataItem($(e.currentTarget).closest('tr'));
            url = decodeURI(url);
            url = url.replace('ITEMID', dataItem.Id);
            window.location = url;
        }
    },
    initCulture: function (options) {

        options = $.extend({
            name: null,
            numGroupSep: null,
            numDecSep: null,
            //percGroupSep: null,
            //percDecSep: null,
            //currGroupSep: null,
            //currDecSep: null,
            calendar: {
                firstDay: 1,
                G: null,
                g: null,
                d: null,
                T: null,
                t: null,
            }
        }, options);

        const culture = kendo.culture();
        culture.numberFormat[','] = options.numGroupSep;
        culture.numberFormat['.'] = options.numDecSep;
        culture.numberFormat.percent[','] = options.numGroupSep;
        culture.numberFormat.percent['.'] = options.numDecSep;
        culture.numberFormat.currency[','] = options.numGroupSep;
        culture.numberFormat.currency['.'] = options.numDecSep;

        culture.calendar.firstDay = 1;

        // general date/time pattern (long time) ("M/d/yyyy h:mm:ss tt" for en-US)
        culture.calendar.patterns.G = options.calendar.G;
        // general date/time pattern (short time) ("M/d/yyyy h:mm tt" for en-US)
        culture.calendar.patterns.g = options.calendar.g;

        // short date pattern ("M/d/yyyy" for en-US)
        culture.calendar.patterns.d = options.calendar.d;

        // long time pattern ("h:mm:ss tt" for en-US)
        culture.calendar.patterns.T = options.calendar.T;
        // short time pattern ("h:mm tt" for en-US)
        culture.calendar.patterns.t = options.calendar.t;
    },
    init: function (options) {

        options = $.extend({
            useSvg: false,
        }, options);

        const iconFont = options.useSvg ? 'svg' : 'font';
        kendo.setDefaults('iconType', iconFont);

        const _init = kendo.ui.Popup.fn.init;
        const popup = kendo.ui.Popup.extend({
            init: function (element, options) {
                if (options.appendTo === undefined) {
                    const parentModal = $(options.anchor).closest('.modal-content');
                    if (parentModal.length > 0) {
                        options.appendTo = parentModal[0];
                    }
                }

                _init.call(this, element, options);
            }
        });

        kendo.ui.plugin(popup);
    },
    dateUtcToLocal: function (date, format) {
        if (date) {
            format = format || nef.dateFormat;
            var result = kendo.toString(date, format);
            //var result = '';
            //if (format) {
            //    result = kendo.toString(date, format);
            //} else {
            //    result = date.toLocaleString();
            //    result = result.substr(result, result.lastIndexOf(':'));
            //}
            return result;
        }
        return '';
    },
    dateTimeUtcToLocal: function (date, format) {
        if (date) {
            var dateObj = typeof date === 'string' ? new Date(date) : date;
            format = format || nef.dateTimeFormat;
            var result = kendo.toString(dateObj, format);
            return result;
        }
        return '';
    },
    renderPlotBand: function (e, value, width, color) {
        var valueAxis = e.sender.getAxis("valueAxis");
        var valueSlot = valueAxis.slot(value);

        var categoryAxis = e.sender.getAxis("categoryAxis");
        var lastCategoryIndex = Math.max(1, categoryAxis.range().max);
        var minCategorySlot = categoryAxis.slot(0);
        var maxCategorySlot = categoryAxis.slot(lastCategoryIndex);

        var line = new kendo.drawing.Path({
            stroke: {
                color: color || '#FF0000',
                width: width || 2
            }
        });
        line.moveTo([minCategorySlot.origin.x, valueSlot.origin.y]).lineTo([maxCategorySlot.origin.x, valueSlot.origin.y]);

        e.sender.surface.draw(line);
    },
    fileSizeFriendly: function (bytes, si) {
        var thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + 'B';
        }
        var units = si
            ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + '' + units[u];
    },
    Editor: {
        //$(document).ready(function () {
        //    var turndownService = new TurndownService();
        //    $("#CtoNotes").kendoEditor({
        //        serialization: {
        //            custom: function (html) {
        //                console.log('serialization: markdown raw', html)

        //                var markdown = turndownService.turndown(html);
        //                return markdown;
        //            }
        //        },
        //        deserialization: {
        //            custom: function (markdown) {
        //                console.log('deserialization: html deserialize', markdown)
        //                markdown = kendo.htmlEncode(markdown);
        //                var html = marked.parse(markdown)
        //                console.log('deserialization: markdown', html)
        //                return html;
        //            }
        //        }
        //    });
        //});
    }
}, nef.Kendo);

nef.Kendo.init();

if (nef.culture) {
    nef.Kendo.initCulture(nef.culture);
}

nef.Bootstrap = $.extend(true, {
    prepeareFormMVC: function (options) {

        options = $.extend({
            debug: false,
            formSelector: '.nef-content form',
            form: null
        }, options);

        var scope = {
            seconds: nef.timezone * 60 * 60,
            convertToUserDate: function (picker) {
                if (!picker) {
                    return;
                }

                let utcDate;
                let userDate;

                utcDate = picker.min();
                if (utcDate) {
                    userDate = utcDate.addSeconds(scope.seconds);
                    picker.min(userDate);
                }

                utcDate = picker.max();
                if (utcDate) {
                    userDate = utcDate.addSeconds(scope.seconds);
                    picker.max(userDate);
                }

                utcDate = picker.value();
                if (utcDate) {
                    userDate = utcDate.addSeconds(scope.seconds);
                    picker.value(userDate);
                }
            },
            form: $(options.formSelector)
        };

        scope.form.find('.input-validation-error').each(function (index, el) {
            $(el).addClass('border-danger');
            $(el).closest('.form-group').addClass('has-error');
        });

        $(document).ready(function () {
            scope.form.find('.k-datetimepicker [data-role]').each(function () {
                var picker = $(this).data('kendoDateTimePicker');
                scope.convertToUserDate(picker);
            });
            scope.form.find('.k-datepicker [data-role]').each(function () {
                var picker = $(this).data('kendoDatePicker');
                scope.convertToUserDate(picker);
            });
            scope.form.find('.k-timepicker [data-role]').each(function () {
                var picker = $(this).data('kendoTimePicker');
                scope.convertToUserDate(picker);
            });


            //Nefab Douglas[2024-01-03]: Kendo seems to have an issue with group separator as . (dot).
            //Nefab Douglas[2024-01-03]: Issued the error to Kendo: https://www.telerik.com/forums/numerictextboxfor-showing-incorrect-value-when-using-culture-pt-br
            var culture = kendo.culture();
            var isDotGroupSeparator = culture.numberFormat[','] === '.';
            if (isDotGroupSeparator) {

                scope.form.find('.k-numerictextbox [data-role]').each(function () {

                    var textbox = $(this).data('kendoNumericTextBox');
                    if (
                        (textbox.options.decimals && textbox.options.decimals > 0) //Doubles, Decimals and Floats...
                        ||
                        (textbox.options.format.indexOf('p') === 0) //Percentages...
                    ) {
                        var valueInput = textbox.element.attr('value');
                        if (valueInput && valueInput !== '') {
                            /*console.log('value', valueInput, typeof valueInput, textbox, this);*/
                            textbox.value(parseFloat(valueInput));
                        }
                    }
                });
            }
        });
    }
}, nef.Bootstrap);



nef.signalR = $.extend(true, {
    build: function (options) {

        options = $.extend({
            debug: false,
            name: '',
            path: '',
            signalRLogLevel: signalR.LogLevel.Error,
            automaticReconnect: true,
            statefulReconnect: true,
            retryConnectSeconds: 60,
            showFlashMessages: false,

            messages: {
                reconnecting: 'SignalR is trying to reconnect...',
                closed: 'SignalR connection is closed!',
                connectionFailed: '<strong>SignalR connection failed!</strong> '
            },

            onStart: null,
            onConnecting: null,
            onConnected: null,
            onReconnecting: null,
            onReconnected: null,
            onClose: null,
            onError: null,

        }, options);


        if (!options.name || options.name === '') {
            console.error('nef.signalR: Missing name!');
        }
        if (!options.path || options.path === '') {
            console.error('nef.signalR: Missing path!');
        }

        var log = function () {
            if (options.debug) {
                return Function.prototype.bind.call(nef.log, nef, options.name + ':');
            } else {
                return function () { };
            }
        }();

        var scope = {
            retryTimeoutId: null,
            retryConnectAttempt: 0,

            flashError: null,
            flashReconnecting: null,

            connection: null,
            hubStart: null,
            forcedDisconnect: false,


            init: function () {

                if (options.debug) {
                    log('init...');
                }
                var builder = new signalR.HubConnectionBuilder();

                if (options.signalRLogLevel) {
                    builder.configureLogging(options.signalRLogLevel);
                }

                builder.withUrl(options.path);

                if (options.automaticReconnect) {
                    builder.withAutomaticReconnect();
                }
                if (options.statefulReconnect) {
                    builder.withStatefulReconnect();
                }

                scope.connection = builder.build();
                scope.connection.onreconnecting(function (error) {
                    log('Reconnecting...', error);

                    if (scope.flashError) {
                        scope.flashError.remove();
                    }
                    if (options.showFlashMessages) {
                        scope.flashReconnecting = nef.flash({ message: options.messages.reconnecting, type: 'warning' });
                    }
                    if (options.onReconnecting) {
                        options.onReconnecting(error);
                    }
                });
                scope.connection.onreconnected(function (connectionId) {
                    log('Reconnected!', connectionId);
                    if (options.onReconnected) {
                        options.onReconnected(connectionId);
                    }
                    scope.onConnected(connectionId);
                });
                scope.connection.onclose(function () {
                    log('Connection is closed!');

                    if (!scope.forcedDisconnect) {
                        if (options.retryConnectSeconds > 0) {
                            scope.retryTimeoutId = window.setInterval(function () {
                                log('Connection is closed (' + scope.connection.state + ') but waitied ' + scope.retryConnectSeconds + ' seconds so lets try again now!');
                                if (scope.connection.state === signalR.HubConnectionState.Disconnected) {
                                    scope.connect();
                                }
                            }, 1000 * options.retryConnectSeconds);
                        }
                    }

                    if (scope.flashError) {
                        scope.flashError.remove();
                    }
                    if (options.showFlashMessages) {
                        scope.flashError = nef.flash({ message: options.messages.closed });
                    }
                    if (options.onClose) {
                        options.onClose(scope.forcedDisconnect);
                    }
                });

                if (options.onStart) {
                    options.onStart(scope.connection);
                }

            },
            connect: function () {

                var deferred = $.Deferred();

                scope.forcedDisconnect = false;

                if (!scope.connection) {
                    scope.init();
                }

                if (scope.connection.state === signalR.HubConnectionState.Disconnected) {

                    log('Connecting...');

                    if (options.onConnecting) {
                        options.onConnecting();
                    }

                    scope.hubStart = scope.connection.start()
                        .then(function () {
                            var connectionId = scope.connection.connectionId;
                            log('Connected!', connectionId);
                            scope.onConnected(connectionId);
                            deferred.resolve(connectionId);

                        }).catch(function (err) {
                            console.error('nef.signalR.connect: Connection failed!', err);
                            log('Connection failed!', err);

                            if (scope.flashError) {
                                scope.flashError.remove();
                            }
                            if (options.showFlashMessages) {
                                scope.flashError = nef.flash({ message: options.messages.connectionFailed + ' ' + err.toString() });
                            }
                            if (options.onError) {
                                options.onError(err);
                            }

                            deferred.reject(err);
                        });
                }
                else {
                    log(`Already Connected! (State: ${scope.connection.state})`);
                    deferred.resolve(scope.connection.connectionId);
                }

                return deferred.promise();
            },
            disconnect: function () {
                if (!scope.connection) {
                    return;
                }

                scope.forcedDisconnect = true;
                scope.connection.stop();
            },
            onConnected: function (connectionId) {



                if (scope.retryTimeoutId) {
                    window.clearInterval(scope.retryTimeoutId);
                    scope.retryTimeoutId = null;
                }

                scope.retryConnectAttempt = 0;

                if (scope.flashError) {
                    scope.flashError.remove();
                }
                if (scope.flashReconnecting) {
                    scope.flashReconnecting.remove();
                }

                if (options.onConnected) {
                    options.onConnected(connectionId);
                }
            },
            invoke: function (name, data) {

                var deferred = $.Deferred();

                scope.connect().done(function () {

                    log('Invoking ' + name + '...', data);

                    scope.connection.invoke(name, data)
                        .then(function () {

                            log('Invoked ' + name + '!', data);

                            deferred.resolve();

                        }).catch(function (err) {
                            log('Invoke error for ' + name, err.toString(), err);
                            if (options.onError) {
                                options.onError(err);
                            }
                            deferred.reject(err);
                        });


                }).fail(function (err) {
                    deferred.reject(err);
                });

                return deferred.promise();

            }
        };



        return scope;
    }
}, nef.signalR);



if (window.$ && !$.postJSON) {
    $.postJSON = function (url, data, successResponse, failedResponse) {
        return $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            data: data ? JSON.stringify(data) : null,
            success: function (response, textStatus, jqXHR) {
                if (successResponse) {
                    successResponse(response, textStatus, jqXHR);
                }
            },
            error: function (response, textStatus, errorThrown) {
                if (failedResponse) {
                    failedResponse(response, textStatus, errorThrown);
                }
            }
        });
    };
}



$.fn.extend({
    nefImageGallery: function (o) {

        o = $.extend(true, {
            debug: false,
            selectors: {
                modal: '#e-modal-gallery'
            },
            modalTemplate: '<div id="e-modal-gallery" class="modal fade" role="dialog">' +
                '    <div class="modal-dialog modal-lg">' +
                '        <div class="modal-content">' +
                '            <div class="modal-header">' +
                '                <h4 class="modal-title"></h4>' +
                '                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="{t(Common.Close)}"></button>' +
                '            </div>' +
                '            <div class="modal-body" style="padding: 5px; text-align:center;"></div>' +
                '        </div>' +
                '    </div>' +
                '</div>'
        }, o);

        var s = {
            $modal: $(o.selectors.modal)
        };

        return this.click(function (e) {
            var isImage = $(this).data('image');
            if (isImage) {
                nef.stopEvent(e);

                if (!s.$modal[0]) {
                    s.$modal = $('body').append(o.modalTemplate).find(o.selectors.modal);
                }

                var href = $(this).attr('href');
                s.$modal.find('.modal-title').text($(this).data('title'));
                s.$modal.find('.modal-body').html('<a href="' + href + '" target="_blank"><img src="' + href + '" alt="" class="img-fluid" style="margin:0 auto;" /></a>');
                s.$modal.modal('show');

                return false;
            }
        });
    },
    nefMaxHeight: function (o) {

        o = $.extend(true, {
            debug: false,
            selectors: {
                excluded: '.header, .navbar, footer'
            },
            css: {
                margin: 0
            },
            forceHeight: true,
            callback: null,
        }, o);

        var s = {
            $el: $(this),
            $excluded: $(o.selectors.excluded)
        };

        var maxHeight = function () {
            var height = $(window).outerHeight(true);
            s.$excluded.each(function () {
                height -= $(this).outerHeight(true);
            });
            var heightCss = o.forceHeight ? { height: height } : { maxHeight: height };
            var css = $.extend(o.css, heightCss);
            s.$el.css(css);
            if (o.callback && typeof o.callback === 'function') {
                o.callback(this);
            }
        };

        $(document).ready(function () {
            maxHeight();
        });
        $(window).resize(function () {
            maxHeight();
        });
    },
    nefSideMenu: function (options) {

        options = $.extend(true, {
            debug: false,
            extraHeight: -51
        }, options);

        var scope = {
            panels: $('.nef-sidemenu'),
            buttons: $(this)
        };

        var maxHeight = function () {
            var height = $(document).outerHeight(true);
            height += options.extraHeight;
            scope.panels.css({ height: height, maxHeight: height });
        };

        maxHeight();

        $(window).resize(function () {
            maxHeight();
        });

        var closeIfClickedOutside = function (e) {

            if ($(e.target).hasClass('k-list-scroller')) {
                return;
            }

            if (scope.buttons.is(e.target) || scope.buttons.has(e.target).length > 0) {
                return;
            }

            if (!scope.panels.is(e.target) && scope.panels.has(e.target).length === 0) {
                scope.panels.hide().data('open', false);
                scope.buttons.removeClass('open');
                $(document).off('mouseup', closeIfClickedOutside);
            }
        };


        return $(this).each(function () {
            //var panelSelector = $(this).data('sidemenu');
            var panelSelector = $(this).data('bsTarget');

            //console.log(this, $(this).data());

            var panel = $(panelSelector);
            panel.data('open', false);

            $(this).click(function (e) {
                nef.stopEvent(e);

                if (!panel.nefLoaded) {

                    var data;
                    var panelId = panel.attr('id');

                    switch (panelId) {
                        case 'nef-account':

                            kendo.ui.progress(panel, true);

                            data = {
                                returnUrl: window.location.pathname + window.location.search
                            };

                            $.post(nef.sitePath + 'Base/Account/DetailsAjax', data, function (result) {

                                kendo.ui.progress(panel, false);
                                panel.nefLoaded = true;
                                panel.html(result);

                                panel.find('.close').click(function (e) {
                                    nef.stopEvent(e);
                                    panel.hide();
                                    panel.data('open', false);
                                    $(document).off('mouseup', closeIfClickedOutside);
                                });
                            });


                            break;
                        case 'nef-helpPage':

                            kendo.ui.progress(panel, true);

                            data = {
                                pageName: panel.data('pagename')
                            };

                            $.post(nef.sitePath + 'Base/Pages/HelpPageAjax', data, function (result) {

                                kendo.ui.progress(panel, false);
                                panel.nefLoaded = true;
                                panel.html(result);

                                panel.find('.close').click(function (e) {
                                    nef.stopEvent(e);
                                    panel.hide();
                                    panel.data('open', false);
                                    $(document).off('mouseup', closeIfClickedOutside);
                                });

                                var supportForm = panel.find('#nef-helpPage-support');

                                nef.formAjaxSubmit({
                                    form: supportForm.find('form'),
                                    success: function (result) {
                                        if (result && result.Success) {
                                            supportForm.html('<div class="alert alert-success" role="alert">' + result.Message + '</div>');
                                            panel.find('#nef-helpPage-support-btn').remove();
                                        } else {
                                            supportForm.append('<div class="alert alert-danger alert-dismissible mt-3" role="alert"><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="{t(Common.Close)}"></button>' + result.Message + '</div>');
                                        }
                                    }
                                });
                            });

                            break;
                    }
                }

                panel.show();
                //var open = panel.data('open');
                //scope.panels.hide().data('open', false);
                //scope.buttons.removeClass('open');

                //if (!open) {
                //    $(this).addClass('open');
                //    panel.show();
                //    $(document).on('mouseup', closeIfClickedOutside);
                //}
                //panel.data('open', !open);
            });

            //panel.find('.close').click(function (e) {
            //    nef.stopEvent(e);
            //    panel.hide();
            //    panel.data('open', false);
            //    $(document).off('mouseup', closeIfClickedOutside);
            //});
        });
    },
    nefPopup: function (options) {
        options = $.extend(true, {
            debug: false,
            name: '_blank',
            height: 900,
            width: 600,
            top: 10,
            left: 10,
            toolbar: 'no',
            location: 'no',
            directories: 'no',
            scrollbars: 'yes',
            resizable: 'yes'
        }, options);

        var extras = 'toolbar=' + options.toolbar + ',location=' + options.location + ',directories=' + options.directories + ',height=' + options.height + ',width=' + options.width + ',top=' + options.top + ',left=' + options.left + ',scrollbars=' + options.scrollbars + ',resizable=' + options.resizable;

        return $(this).click(function (e) {
            nef.stopEvent(e);
            window.open($(this).attr('href'), options.name, extras);
        });
    },
    nefAppMenu: function (options) {

        options = $.extend(true, {
            debug: false,
            userId: '',
            url: nef.sitePath + 'Base/Account/GetAppMenu',
            timeout: 600,
            appHideCss: 'nef-hide',
            appSearchThreshold: 10
        }, options);

        var scope = {
            key_data: 'nef.AppMenu.Data_' + options.userId,
            key_time: 'nef.AppMenu.Time_' + options.userId,
            key_failed: 'nef.AppMenu.Failed_' + options.userId
        };

        var renderHtml = function (self, result) {

            if (self && result && result.Success && result.Data && result.Data.length > 0) {

                //var squares = '';
                //for (var i = 0; i < 9; i++) {
                //    squares += '<div class="square"></div>';
                //}
                //var button = $('<button class="nef-appmenu-btn">' + squares + '</button>');

                var button = $('<button class="nef-appmenu-btn"><span></span></button>');
                self.html(button);

                var hostname = window.location.hostname;
                if (hostname === 'localhost') {
                    hostname = 'my.nefab.com';
                }

                var length = result.Data.length;
                var isMobile = nef.isMobileDevice();
                var searchEnabled = length > options.appSearchThreshold;
                var cssContainer = 'nef-appmenu-container';

                if (isMobile) {
                    cssContainer += ' nef-isMobile';
                }
                var html = '<div class="' + cssContainer + '"><div class="nef-appmenu-wrapper"><div class="nef-appmenu-arrow"></div><div class="nef-appmenu-apps">';


                if (searchEnabled) {
                    html += '<div class="nef-appmenu-search mb-2">';
                    html += '<div class="input-group input-group-sm">';
                    html += '<input type="text" class="form-control" tabindex="10" placeholder="Search app..." aria-label="Search app" />';
                    //html += '<span class="input-group-text bg-light"><i class="fa fa-regular fa-search"></i></span>';
                    html += '</div>';
                    html += '</div>';
                }

                html += '<div class="nef-appmenu-apps">';

                var node, rel = '', cssParent = '', cssIcon = '', styles = '', extension = '';

                for (var i = 0; i < length; i++) {
                    node = result.Data[i];

                    if (node.Link && node.Link !== '') {
                        rel = '';
                        if (node.Link.toLowerCase().indexOf(hostname) === -1) {
                            rel = ' rel="noopener noreferrer"';
                        }

                        cssParent = 'nef-appmenu-app nef-appmenu-app_' + node.Id;
                        cssIcon = 'nef-appmenu-app-icon';
                        styles = '--nef-appmenu-app-color:' + node.Color + ';';

                        if (node.IconUrl && node.IconUrl !== '') {
                            cssIcon += ' nef-iconUrl';
                            styles += '--nef-appmenu-app-iconUrl:url(' + node.IconUrl + ');';

                            if (node.IconUrl.indexOf('.') > -1) {
                                extension = node.IconUrl.split('.').pop().split(/\#|\?/)[0];
                                cssIcon += ' nef-iconUrl-' + extension.toLowerCase();
                            }
                        }
                        else {
                            cssIcon += ' nef-mynefabregular';
                        }

                        html += '<a class="' + cssParent + '" href="' + node.Link + '" style="' + styles + '" ' + (node.OpenInNewTab ? 'target="_blank"' : '') + '' + rel + ' tabindex="' + (11 + i) + '">';
                        html += '<span class="' + cssIcon + '">' + String.fromCharCode(node.Icon) + '</span>';
                        html += '<span class="nef-appmenu-app-title">' + node.Title + '</span>';
                        html += '</a>';
                    }
                }
                html += '</div></div></div>';

                var container = $(html);

                if (searchEnabled) {
                    container.find('.nef-appmenu-search .form-control').on('keyup', function (e) {

                        var apps = container.find('.nef-appmenu-apps .nef-appmenu-app');
                        var value = $(e.target).val().toLowerCase();

                        if (value === '') {
                            apps.each(function (i, el) {
                                var app = $(this);
                                app.removeClass(options.appHideCss);
                                app.attr('tabindex', 11 + i);
                            });
                        }
                        else {
                            apps.each(function (i, el) {
                                var app = $(this);
                                var name = app.find('.nef-appmenu-app-title').text().toLowerCase();
                                if (name.indexOf(value) > -1) {
                                    app.removeClass(options.appHideCss);
                                    app.attr('tabindex', 11 + i);

                                } else {
                                    app.addClass(options.appHideCss);
                                    app.attr('tabindex', 10000 + i);
                                }
                            });
                        }

                    });
                }

                self.append(container);

                var open = false;
                button.click(function (e) {
                    nef.stopEvent(e);
                    if (!open) {
                        container.show();

                        if (searchEnabled && !isMobile) {
                            container.find('.nef-appmenu-search .form-control').focus();
                        }

                    } else {
                        container.hide();
                    }
                    open = !open;
                });

                $(document).mouseup(function (e) {
                    if (!button.is(e.target) && !container.is(e.target) && container.has(e.target).length === 0) {
                        open = false;
                        container.hide();
                    }
                });
            }
            else {
                //window.location = window.location;
                //nef.flash({
                //    message: '<b>Failed to load app menu!</b> Please reload the page.'
                //});
                //getData();
            }
        };
        var getData = function () {

            $.ajax({
                url: options.url,
                type: 'POST',
                dataType: 'json',
                success: function (result) {
                    sessionStorage.setItem(scope.key_data, JSON.stringify(result));
                    sessionStorage.setItem(scope.key_time, new Date());
                    renderHtml(self, result);
                    sessionStorage.removeItem(scope.key_failed);
                    $(document).trigger('nefAppMenu_ready');
                },
                error: function (xhr) {
                    console.error('$.fn.nefAppMenu: request failed: ' + (xhr ? xhr.status : 'N/A'), xhr ? xhr.statusText : '', xhr);

                    // Check if failed before...
                    var hasFailed = sessionStorage.getItem(scope.key_failed);
                    // Mark as failed...
                    sessionStorage.setItem(scope.key_failed, 'true');

                    if (xhr.status === 401 && !hasFailed) {
                        window.location = window.location;
                    }
                }
            });
        };

        var self = $(this);
        var data = sessionStorage.getItem(scope.key_data);
        var time = sessionStorage.getItem(scope.key_time);

        if (data && time && new Date(time).diff() < options.timeout) {
            renderHtml(self, JSON.parse(data));
            $(document).trigger('nefAppMenu_ready');
        } else {
            getData();
        }
    },
    nefSiteNav: function (options) {

        options = $.extend(true, {
            debug: false,
            pinned: true,
            lnkToggler: '#nef-nav-btn-toggle',
            lnkPinner: '.nef-nav-item-pin .nav-link',
            pnlActions: '.nef-header-btns',
            pnlSiteNav: '.nef-nav-collapse',
            keyState: 'nef.SiteNav_pinned',
            messages: {
                togglerHideTitle: 'Unpin menu',
                toggerShowTitle: 'Pin menu',
            }
        }, options);

        var scope = {
            parent: $(this),
            pnlNavs: $(options.pnlSiteNav),
            lnkToggler: $(options.lnkToggler),
            lnkPinner: $(this).find(options.lnkPinner),
            classShow: 'nef-show',
            classHide: 'nef-hide',
            classUnpinned: 'nef-unpinned',
            show: $(this).hasClass('show'),
            saveState: function (pinned) {
                localStorage.setItem(options.keyState, pinned);
            },
            loadState: function () {
                const pinnedString = localStorage.getItem(options.keyState);
                return pinnedString;
            },
            pin: function (pin) {
                if (pin) {
                    scope.parent.removeClass(scope.classUnpinned);
                    scope.lnkPinner.attr('title', options.messages.togglerHideTitle);
                } else {
                    scope.parent.addClass(scope.classUnpinned);
                    scope.lnkPinner.attr('title', options.messages.toggerShowTitle);
                }
            },
            toogle: function (show) {
                if (show) {
                    scope.lnkToggler.removeClass(scope.classHide);
                    scope.pnlNavs.removeClass(scope.classHide);

                    scope.lnkToggler.addClass(scope.classShow);
                    scope.pnlNavs.addClass(scope.classShow);

                    scope.lnkToggler.addClass('nef-show-clicked');

                } else {
                    scope.lnkToggler.removeClass(scope.classShow);
                    scope.pnlNavs.removeClass(scope.classShow);

                    scope.lnkToggler.addClass(scope.classHide);
                    scope.pnlNavs.addClass(scope.classHide);

                    scope.lnkToggler.removeClass('nef-show-clicked');
                }
            },
        };

        scope.lnkPinner.click(function (e) {
            nef.stopEvent(e);
            const pinned = scope.parent.hasClass(scope.classUnpinned);
            console.log('pinned', pinned);
            scope.saveState(pinned);
            scope.pin(pinned);
            this.blur();
        });

        scope.lnkToggler.click(function (e) {
            nef.stopEvent(e);
            const width = scope.parent.width();
            const height = scope.parent.height();
            var visible = width * height;
            //console.log('visible', visible, [width, height]);
            scope.toogle(visible === 0);
        });

        const pinnedString = scope.loadState();
        if (pinnedString) {
            // User has done a choice...
            const pinned = pinnedString === 'true';
            scope.pin(pinned);
        }
        else {
            scope.pin(options.pinned);
        }


        nef.pin = scope.pin;
        nef.toggle = scope.toogle;
    }
});

//Primary: #405369
//Secondary: #F47721

//console.info(
//    '%c nef.base %c v' + nef.version + ''
//    , 'color: #FFFFFF; background: #144E8C; font-weight: 700; font-size: 16px; padding:10px 5px 10px 25px;border:2px solid #FFF;border-right:0;'
//    , 'color: #F47721; background: #F3F3F3; font-weight: 700; font-size: 16px; padding:10px 50px 10px 5px;border:2px solid #FFF;border-left:0;'
//);

//console.info(
//    '%c NEFAB \n %c nef.base %c v' + nef.version + ''
//    , 'color: #FFFFFF; background: #144E8C; font-weight: 700; font-size: 1rem; padding:10px 80px;border:0px solid #FFF;border-right:0;display:block;'
//    , 'color: #FFFFFF; background: #144E8C; font-weight: 700; font-size: 1rem; padding:5px 5px 5px 25px;border:0px solid #FFF;border-right:0;'
//    , 'color: #F47721; background: #F3F3F3; font-weight: 700; font-size: 1rem; padding:5px 50px 5px 5px;border:0px solid #FFF;border-left:0;'
//);

console.info(
    '%c NEFAB %cnef.base %cv' + nef.version + ''
    , 'display:inline-block;color:#FFFFFF;background:#144E8C;font-weight:700;font-size:.7rem;padding:.1rem 3rem;border:.2rem solid #144E8C;border-right:0;'
    , 'display:inline-block;color:#405369;background:#f3f3f3;font-weight:700;font-size:.7rem;padding:.1rem .1rem .1rem 1rem;border:.2rem solid #144E8C;border-right:0;'
    , 'display:inline-block;color:#F47721;background:#f3f3f3;font-weight:700;font-size:.7rem;padding:.1rem 1rem .1rem .1rem;border:.2rem solid #144E8C;border-left:0;'
);
//console.info(
//    '%cDANGER ZONE'
//    , 'display:inline-block;color: #dc3545; background: #000000; font-weight: 700; font-size: 1rem; padding:1rem 6rem;border:3px solid #dc3545;'
//);
